<template>
  <div>
    <div class="user_info">
      <div class="avatar">
        <img
          :src="
            !$store.state.userAvatar ? defaultAvatar : $store.state.userAvatar
          "
          alt
        />
      </div>
      <div class="user_name">{{ $store.state.userName }}</div>
    </div>
    <div class="user_list">
      <div
        class="user_item"
        v-for="(item, index) in $store.state.userList"
        :key="index"
        :class="{ user_selected: item.isSelected }"
        @click="checkUser(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultAvatar: require("@/assets/img/pic_head_nor.png")
    };
  },
  mounted() {
    var _this = this;
  },

  methods: {
    checkUser(item) {
      console.log(item);
      for (let i of this.$store.state.userList) {
        i.isSelected = false;
      }
      if (item.name == "全部订单") {
        this.$router.push({ path: "/user/order" });
      }
      if (item.name == "退款订单") {
        this.$router.push({ path: "/user/order/refund" });
      }
      if (item.name == "我的钱包") {
        this.$router.push({ path: "/user/wallet" });
      }
      if (item.name == "我的账单") {
        this.$router.push({ path: "/user/bill" });
      }
      if (item.name == "我的商品") {
        this.$router.push({ path: "/user/commodity" });
      }
      if (item.name == "异常跟进") {
        this.$router.push({ path: "/user/followup/record" });
      }
      if (item.name == "订单盈亏") {
        this.$router.push({ path: "/user/profitLoss/order" });
      }
      if (item.name == "批量下单") {
        this.$router.push({ path: "/user/batch/order" });
      }
      if (item.name == "消息通知") {
        this.$router.push({ path: "/user/message" });
      }
      if (item.name == "平台公告") {
        this.$router.push({ path: "/user/notice" });
      }
      if (item.name == "维权中心") {
        this.$router.push({ path: "/user/right" });
      }
      if (item.name == "帮助中心") {
        this.$router.push({ path: "/user/help" });
      }
      if (item.name == "意见反馈") {
        this.$router.push({ path: "/user/feedback" });
      }
      if (item.name == "安全设置") {
        this.$router.push({ path: "/user/safety" });
      }
      if (item.name == "个人设置") {
        this.$router.push({ path: "/user/setting" });
      }
      if (item.name == "关于我们") {
        this.$router.push({ path: "/user/about" });
      }
      item.isSelected = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.user_info {
  height: 155px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0;
  border-bottom: 1px solid #e8eef5;
  .avatar {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    // background: url("./../../assets/img/pic_head_nor.png") no-repeat;
    background-size: cover;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .user_name {
    font-size: 16px;
    color: #2f3133;
    height: 16px;
    line-height: 1;
  }
}
.user_list {
  padding: 16px 0;
  background: #fff;
  .user_item {
    height: 50px;
    font-size: 16px;
    color: #5e6066;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 8px;
    &:hover {
      color: #3455d3;
    }
    &.user_selected {
      background: #3455d3;
      color: #fff;
      // border-left: 4px solid #3455d3;
      // color: #3455d3;
      // padding-right: 4px;
    }
  }
  .user_item:nth-child(5),
  .user_item:nth-child(9) {
    margin-bottom: 32px;
    position: relative;
  }
  .user_item:nth-child(5)::after,
  .user_item:nth-child(9)::after {
    content: "";
    position: absolute;
    height: 1px;
    width: 100%;
    background: #e8eef5;
    bottom: -16px;
    left: 0px;
  }
  .user_item:last-child {
    margin-bottom: 0;
  }
}
</style>
